import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DeliveryPackageWeightCtrl implements IController {
  items: any;

  private totalWeight: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.totalWeight = _.reduce(this.items, (sum, i) => {
      return sum + _.get(i, 'weight', 0);
    }, 0);
  };

  $onChanges(changes) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryPackageWeight', {
    bindings: {
      items: '<'
    },
    template: require('./delivery-package-weight.html').default,
    controller: DeliveryPackageWeightCtrl
  });
